import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from '@mui/material';

import { trpc } from '../../api/trpc';

import { ControlBox } from '../../atoms/control-box';
import { StatusDot } from '../../atoms/status-dot';
import { Row } from '../../atoms/row';
import { HelpButton } from '../../atoms/help-button';

export const NetworkOnlineStatus = () => {
  const { data: internetStatus } = trpc.network.getOnlineStatus.useQuery(
    { target: 'internet' },
    { refetchInterval: 5000 }
  );
  const { data: cloudStatus } = trpc.network.getOnlineStatus.useQuery(
    { target: 'cloud' },
    { refetchInterval: 5000 }
  );
  const { data: internalCloudStatus } = trpc.network.getOnlineStatus.useQuery(
    { target: 'internal-cloud' },
    { refetchInterval: 5000 }
  );

  return (
    <ControlBox
      title={
        <>
          <FormattedMessage
            id="settings.service.network.online.internet"
            defaultMessage="Přístup na internet"
          />
          <HelpButton
            variant="dialog"
            title={
              <FormattedMessage
                id="settings.service.network.online.internet"
                defaultMessage="Přístup na internet"
              />
            }
            content={
              <>
                <FormattedMessage
                  id="settings.service.network.online.internet.help"
                  defaultMessage="Přístup na internet je potřeba pro vzdálený přístup, aktualizace systému, spotové ceny a další funkce. Pro plnou funkčnost musí být všechny tři indikátory zelené.{br}{br}První indikátor zobrazuje dostupnost internetu (ping 8.8.8.8).{br}{br}Druhý indikátor zobrazuje dostupnost internetu včetně DNS (ping infigy.cz).{br}{br}Třetí indikátor zobrazuje přístup k interním cloudovým službám Infigy (dostupnost VPN).{br}{br}Pokud je s připojením problém, zkontrolujte prosím kabel, nebo kontaktujte správce sítě, jestli nemá místní síť restrikce na komunikaci do internetu.{br}{br}{wikiLink}"
                  values={{
                    br: <br />,
                    wikiLink: (
                      <Link
                        href="https://infigy.cz/app-redirect/internet-access"
                        target="_blank"
                        rel="noopener"
                      >
                        <FormattedMessage
                          id="settings.service.network.online.internet.help.wikiLink"
                          defaultMessage="Více informací v naší wiki."
                        />
                      </Link>
                    ),
                  }}
                />
              </>
            }
          />
        </>
      }
      control={
        <Row gap={0.25}>
          <StatusDot alive={internetStatus} />
          <StatusDot alive={cloudStatus} />
          <StatusDot alive={internalCloudStatus} />
        </Row>
      }
      fullWidth
    />
  );
};
